import { COURSE_LANDING_PAGE_LOAD_START, COURSE_LANDING_PAGE_LOAD_COMPLETE, COURSE_LANDING_PAGE_LOAD_ERR } from '../actions/actionTypes';
import initialState from './initialState';
import { clearStateById } from '../utils/state';

function courseLandingPageReducer(state = initialState.courseLandingPage, action) {
  const courseLandingPage = {
    ids: state.ids.slice(),
    byId: { ...state.byId }
  };
  let stateId = `${action.key}.${action.objectId}`;

  switch(action.type) {
    case COURSE_LANDING_PAGE_LOAD_START:
      clearStateById(courseLandingPage.ids, courseLandingPage.byId, stateId);
      return courseLandingPage;
    case COURSE_LANDING_PAGE_LOAD_COMPLETE:
      courseLandingPage.ids.push(stateId);
      courseLandingPage.byId[stateId] = action.data;
      return courseLandingPage;
    case COURSE_LANDING_PAGE_LOAD_ERR:
      courseLandingPage.ids.push(stateId);
      courseLandingPage.byId[stateId] = { error: action.error };
      return courseLandingPage;
    default:
      return state;
  }
}

export default courseLandingPageReducer;